
        import 'Card.f7f416d.css-module'
        export default {"Card":"Card_Card_f7f416d","Default":"Default_Card_f7f416d"}
    